import React from 'react';
import ProfileList from '../ProfileList/ProfileList';
import ProfileView from '../ProfileView/ProfileView';
import { items } from '../assets';
import arrowSvg from '../assets/circle-arrow-right-regular.svg';
import { Button } from 'reactstrap';
import Carousel from 'scenes/V2/CreatePostScene/EventIntro/Carousel';

const WelcomeSection = ({ go4WorkedJobs, onImReady, institutionsLogoSlides, brandsCarouselRef, brands }) => {
  return (
    <>
      <section id="welcome" className="welcome-section scroll-animate fade-in">
        <div className="layers-wrapper-container scroll-animate slide-right stagger-1">
          <div className="layers-wrapper">
            <ProfileList />
            <ProfileView
              image={items[2].image}
              name={items[2].name}
              address={items[2].location}
              jobsWorked={items[2].workedJobs}
            />
          </div>
        </div>

        <div className="content-info">
          <div>
            <h1 className="header scroll-animate fade-up stagger-1">
              <p>Welcome to the largest network of Athletic Trainers</p>
            </h1>
            <div className="advantage scroll-animate slide-left stagger-2">
              <img src={arrowSvg} alt="arrow-1" />
              <p className="subheader">Hire local athletic trainers</p>
            </div>
            <div className="advantage scroll-animate slide-left stagger-3">
              <img src={arrowSvg} alt="arrow-2" />
              <p className="subheader">Managed credentials, insurance, and payment</p>
            </div>
            <div className="advantage scroll-animate slide-left stagger-4">
              <img src={arrowSvg} alt="arrow-3" />
              <p className="subheader">Hourly or long-term</p>
            </div>
          </div>
          <div className="ready-to-post scroll-animate fade-up stagger-5">
            <Button className="ready-to-post-button" onClick={onImReady}>
              Get Started
            </Button>
            <p>No listing fees</p>
          </div>
        </div>
      </section>

      <div className="brands-container">
        <Carousel
          reference={brandsCarouselRef}
          slides={institutionsLogoSlides()}
          containerClassName="brands"
          viewportClassName="brands"
          emblaClassName="brands"
          options={{
            align: 'start',
            loop: true,
            containScroll: 'trimSnap',
            active: brands.active,
            watchFocus: false,
            watchDrag: false,
          }}
          autoScroll
          autoScrollOptions={{
            playOnInit: true,
            speed: 1.5,
            stopOnInteraction: true,
            stopOnFocusIn: false,
            startDelay: 500,
          }}
        />
      </div>
    </>
  );
};

export default WelcomeSection;
